export const PILLAR_BADGE_ID = "PillarBadgeId";
export const PILLAR_BADGE_TEXT_ID = "PillarBadgeTextId";
export const PILLAR_CONNECT_IMAGE_ID = "PillarConnectImageId";
export const PILLAR_DO_IMAGE_ID = "PillarDoImageId";
export const PILLAR_CELEBRATE_IMAGE_ID = "PillarCelebrateImageId";
export const PILLAR_MOVE_IMAGE_ID = "PillarMoveImageId";
export const PILLAR_CHILL_IMAGE_ID = "PillarChillImageId";
export const PILLAR_ENJOY_IMAGE_ID = "PillarEnjoyImageId";
